import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular/lazy';
import { ISiteIntervention } from '../../entities/interventions/site-intervention.interface';
import { Subject, Subscription } from 'rxjs';
import { SitesInterventionReadService } from '../../services/sites-intervention.read.service';
import { OfflineNotificationService } from '../../services/offline-notification.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'in2-site-selecteur-modal',
  templateUrl: './site-selecteur-modal.component.html',
  styleUrls: ['./site-selecteur-modal.component.scss'],
  standalone: false,
})
export class SiteSelecteurModalComponent implements OnInit, OnDestroy {
  public readonly faChevronLeft = faChevronLeft;
  public readonly faChevronRight = faChevronRight;
  public readonly isLoading = signal(false);
  public queryText = '';
  public readonly sitesResult = signal<ISiteIntervention[]>([]);
  public canQuery = true;

  private queryTextChanged: Subject<string> = new Subject<string>();
  private queryTextChangedSubscription?: Subscription;

  constructor(
    private readonly modal: ModalController,
    private readonly sitesInterventionReadService: SitesInterventionReadService,
    private readonly offlineNotificationService: OfflineNotificationService
  ) {}

  public ngOnDestroy() {
    this.queryTextChangedSubscription?.unsubscribe();
  }

  public ngOnInit() {
    this.queryTextChangedSubscription = this.queryTextChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(newText => {
      try {
        this.sitesResult.set([]);
        this.isLoading.set(true);
        this.sitesInterventionReadService.fetch({ query: newText }).subscribe(res => {
          this.sitesResult.set(res);
          this.isLoading.set(false);
        });
      } catch (error) {
        if (this.offlineNotificationService.isOffline()) {
          this.isLoading.set(false);
        }
      }
    });
  }

  public chooseSite(site: ISiteIntervention) {
    this.modal.dismiss(site);
  }

  public onQueryChange(e: any): void {
    this.queryTextChanged.next(e);
  }

  public back() {
    this.modal.dismiss();
  }
}
